import styled from 'styled-components'

import { ContactAgentEmailModalContent } from '../email-modal/style'

export const WizardWrapper = styled(ContactAgentEmailModalContent)``
